module.exports = __webpack_public_path__ + "img/Touch-screen.7c451f74.svg";